export const iconFontAwesomeSportsFitnessPersonWalking = (
	<i className="fa-solid fa-person-walking"></i>
);
